import {
  Box,
  FormControl,
  FormControlLabel,
  FormLabel,
  MenuItem,
  Paper,
  Radio,
  RadioGroup,
  Stack,
  Typography,
} from "@mui/material";
import { SelectChangeEvent } from "@mui/material/Select";
import { LightStyledSelect } from "../../../components/mui/LightStyledSelect";
import { useI18n } from "../../../hooks/useI18n";
import { ImportDestinationOption } from "../evcImportDestinations";
import { fieldLabelSx, sectionPaperSx } from "./styles";

export function ImportTargetSection({
  targetMode,
  onTargetModeChange,
  importDestinations,
  selectedDestinationId,
  onDestinationChange,
}: {
  targetMode: "new" | "existing";
  onTargetModeChange: (targetMode: "new" | "existing") => void;
  importDestinations: ImportDestinationOption[];
  selectedDestinationId: string;
  onDestinationChange: (event: SelectChangeEvent<string>) => void;
}) {
  const { t } = useI18n();

  return (
    <Paper sx={sectionPaperSx} elevation={0}>
      <Stack spacing={3}>
        <FormControl component="fieldset">
          <FormLabel component="legend" sx={fieldLabelSx}>
            {t("evc_onboarding.target_label")}
          </FormLabel>
          <RadioGroup
            value={targetMode}
            onChange={(event) => onTargetModeChange(event.target.value as "new" | "existing")}
            sx={{ mt: 1 }}
          >
            <FormControlLabel
              value="new"
              control={<Radio />}
              label={<Typography variant="body2">{t("evc_onboarding.target_new_record")}</Typography>}
            />
            <FormControlLabel
              value="existing"
              control={<Radio />}
              label={<Typography variant="body2">{t("evc_onboarding.target_existing_record")}</Typography>}
            />
          </RadioGroup>
        </FormControl>
        <Box sx={{ maxWidth: { xs: "100%", md: 520 } }}>
          <LightStyledSelect
            fullWidth
            name="import-destination"
            label={t("evc_onboarding.destination_label")}
            placeholder={t("evc_onboarding.destination_placeholder")}
            value={selectedDestinationId}
            onChange={onDestinationChange}
            renderValue={(selected) =>
              importDestinations.find((destination) => destination.id === selected)?.label || selected
            }
          >
            {importDestinations.map((destination) => (
              <MenuItem key={destination.id} value={destination.id}>
                {destination.label}
              </MenuItem>
            ))}
          </LightStyledSelect>
        </Box>
      </Stack>
    </Paper>
  );
}
